module.exports = __webpack_public_path__ + "public/img/产品保修-2.eb262368.png";